import React from 'react';
import { Box, Typography } from '@mui/material';

interface ViewProps {
  solutionName: string;
}

const View: React.FC<ViewProps> = ({ solutionName }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
      <Typography
        variant='bodyMd'
        color='text.secondary'
      >
        {solutionName} settings coming soon.
      </Typography>
    </Box>
  );
};

export default View;
